import React, { useState } from "react";
import { Row, Col, Form, Input, InputNumber, Button, Modal } from "antd";
import DatePicker from "@general/datePicker";
import UploadFile from "@general/UploadFile";
import { gql, useMutation } from "@apollo/client";
import { useForm } from "antd/lib/form/Form";

const CREATEEXPENDITURE = gql`
  mutation CreateExpenditure($createInput: CreateExpenditureInput!) {
    createExpenditure(createInput: $createInput) {
      id
    }
  }
`;
function AddNewSideExpenditure({onDataUpdate}) {
  const [error, setError] = useState(null);
  const [refetch, setRefetch] = useState(0);
  const [form] = Form.useForm();
  const [runCreateExpenditure, createExpenditure] = useMutation(
    CREATEEXPENDITURE,
    {
      onCompleted(data) {
        Modal.success({
          title: "موفق",
          content: "هزینه جدید ثبت شد",
          bodyStyle: { direction: "rtl" },
          okText: "باشه",
          onOk: () => form.resetFields()
        });
        onDataUpdate()
      },
      onError(err) {
        console.log("خطا: " + err.message);
        Modal.error({
          title: "مشکلی پیش آمده!",
          content: "لطفا دوباره تلاش کنید!",
          bodyStyle: { direction: "rtl" },
          okText: "باشه",
        });
      },
    }
  );
  const doCreateExpenditure = (createInput) => {
    runCreateExpenditure({
      variables: { createInput },
    });
  };
  const { TextArea } = Input;
  return (
    <Form layout="vertical" onFinish={doCreateExpenditure} form={form}>
      <Row gutter={20}>
        <Col xs={24} md={12}>
          <Form.Item
            name="amount"
            id="amount"
            label="مبلغ هزینه (ریال)"
            decimalSeparator
            rules={[
              {
                required: true,
                message: "لطفا هزینه را وارد کنید!",
              },
              {
                pattern: /^[0-9]*$/,
                message: "لطفا هزینه را به طور صحیح وارد کنید",
              },
            ]}
          >
            <InputNumber
              formatter={(value) =>
                value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
              className="form-input"
              placeholder={"مبلغ هزینه"}
              style={{ textAlign: "left", width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            label="بابت (توضیحات)"
            name="description"
            rules={[{ required: true, message: "این فیلد ضروری است" }]}
          >
            <Input.TextArea rows={2} placeholder="توضیحات" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label="تاریخ وقوع"
            name="occurrenceAt"
            rules={[{ required: true, message: "این فیلد ضروری است" }]}
          >
            <DatePicker
              showToday={false}
              format="YYYY/MM/DD"
              className="rtl"
              placeholder="تاریخ وقوع"
            />
          </Form.Item>
          <Form.Item
            name="documentImg"
            label="تصویر سند"
          >
            <UploadFile square />
          </Form.Item>
        </Col>
      </Row>

      <Button type="primary" htmlType="submit">
        ثبت
      </Button>
    </Form>
  );
}

export default AddNewSideExpenditure;
